import { useSelector, useDispatch } from "react-redux";
import {  fetchCliniciansDetails } from "../../redux/clinic/clinicSlice";
import { useCallback } from "react";
import { RootState } from '../../redux';
import { AppDispatch } from '../../redux';

const useFetchDetails = () => {
  const dispatch = useDispatch<AppDispatch>();
  const clinicianState = useSelector((state: RootState) => state.clinics);
  
  // Fetch clinician data with optional ID parameter
  const fetchClinicianData = useCallback(async (id?: string) => {

    try {
      if (!id) throw new Error('Clinician ID is required');
      const result = await dispatch( fetchCliniciansDetails(id)).unwrap();
      return result;
    } catch (error) {
      console.error(`Failed to fetch clinician${id ? ` with ID ${id}` : 's'}:`, error);
      throw error;
    }
  }, [dispatch]);
  
  return { 
    ...clinicianState, 
    fetchClinicianData
  };
};

export default useFetchDetails;
